// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__BLaF1","left":"InfoRow_left__1YLfZ"};